import { CoreIcon } from '../core-icon';
import bankVisaSVG from '../../assets/logos/bank-visa.svg';
import type { IconProps } from '../core-icon';

export const BankVisaIcon = (props: Omit<IconProps, 'src'>) => {
  return <CoreIcon src={bankVisaSVG} {...props} />;
};
